// 需求 R123：報價單建立/編輯兩頁「建立時間區間」共用邏輯。
// 型錄 CatalogPage 原本就有本地版 getMonthDiff（規則 100% 相同），本次抽出僅供報價單兩頁引用，
// 未動 CatalogPage 內的本地版以降低回歸風險（型錄的驗證流程與預設值行為與報價單不同：
// 型錄「必填兩格」、報價單 PM Q1=B「預設空白」+Q2=B「只填一格也可搜尋」）。

// 計算 d2 - d1 的月份差（含日期尾差 0.1，用於「跨度 > 2 個月」的整月比較）。
export const getMonthDiff = (d1, d2) => {
  const a = new Date(d1);
  const b = new Date(d2);
  return (b.getFullYear() - a.getFullYear()) * 12 + b.getMonth() - a.getMonth() + (b.getDate() > a.getDate() ? 0.1 : 0);
};

// 報價單 Section 2 建立時間區間驗證。回傳空字串代表有效；否則回錯誤訊息。
// PM Q2=B：只填其中一格也可搜尋（另一格為空即不送給後端），所以「兩格皆空」與「只填一格」都不視為錯。
// 兩格皆填時才驗證 (a) 起 ≤ 迄、(b) 跨度 ≤ 2 個月。
export const validateProductDateRange = (from, to) => {
  if (!from || !to) return '';
  if (from > to) return '起始日期不可晚於結束日期';
  if (getMonthDiff(from, to) > 2) return '日期區間最長為 2 個月';
  return '';
};
